import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import PATHS from './routesMap'

import Auth from '../views/auth/Auth.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: PATHS.AUTH,
    name: 'Auth',
    component: Auth,
  },
  {
    path: PATHS.BASE_URL,
    name: 'Auth',
    component: Auth,
  },
  {
    path: PATHS.HOME,
    name: 'Home',
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/home/Home.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: PATHS.PERIODS,
    name: 'Period',
    component: () =>
      import(/* webpackChunkName: "period" */ '../views/period/Period.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: PATHS.SELECT_CLIENTS,
    name: 'SelectClients',
    component: () =>
      import(
        /* webpackChunkName: "period" */ '../views/period/SelectClients.vue'
      ),
    meta: {
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: PATHS.SEND_WHATSAPP,
    name: 'WhatsApp',
    component: () =>
      import(/* webpackChunkName: "period" */ '../views/period/WhatsApp.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: PATHS.UNAUTHORIZED,
    name: 'Unauthorized',
    component: () =>
      import(
        /* webpackChunkName: "unauthorized" */ '../views/unauthorized/Unauthorized.vue'
      ),
  },
  {
    path: '*',
    name: 'NotFound',
    component: () =>
      import(
        /* webpackChunkName: "notFound" */ '../views/notFound/NotFound.vue'
      ),
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

router.beforeEach((to, from, next) => {
  if (store.getters.isLoggedIn && to.name === 'Auth') {
    next({ name: 'Home' })
  } else if (to.meta.requiresAuth) {
    if (!store.getters.isLoggedIn && !localStorage.getItem('token')) {
      next({ name: 'Auth' })
    } else {
      if (to.meta.permission !== undefined) {
        if (!store.getters.getModuleUserByCode(to.meta.permission)) {
          if (!store.getters.userIsSampler) {
            next({ name: 'Unauthorized' })
          }
          if (store.getters.userIsSampler && !to.path.includes('precision')) {
            next({ name: 'Unauthorized' })
          }
        }
      }
      next()
    }
  } else {
    next()
  }
})

router.afterEach(async (to, from) => {
  if (!store.getters.isLoggedIn && to.meta.requiresAuth) {
    await store.dispatch('logout')
    router.push(PATHS.AUTH)
  }
})

export default router
